<template>
    <div>
        <h2 id="skills-title" class='h1 text-secondary mb-5'>{{ section.name }}</h2>

        <div class="d-flex flex-wrap" style="max-width: 900px;">
            <div style="width:300px;" class="border-gray-300 border-start border-4 ps-2 my-4" v-for="(skill, skillIdx) in datas.skills" :key="'skill_' + skillIdx">

                <p class="mb-4">
                    <b :class="'text-'+skill.class">{{ skill.title }}</b>
                </p>

                <div style="font-size:1.2rem; line-height:2rem; color:#555;">
                    <div v-for="(subskill, subIdx) in skill.subskills" :key="'subskill_' + skillIdx + '_' + subIdx" class="d-flex">
                        <div style="width:35px;">
                            <i :class="[subskill.icon, 'text-'+skill.class]" class=""></i>
                        </div>
                        <div>
                            {{ subskill.label }}
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SectionSkills',
    components: {
    },
    props : {
        section : { type : Object, required : true }
    },
    data : function() {
        return {

        }
    }
}
</script>

<style scoped>


</style>
